import React, { useEffect, useState } from 'react';
import { Button, Popconfirm, Tooltip } from "antd";
export const ButtonConfirm = (props) => {
    const { title, description, tooltip, disabled, placement, onConfirm, buttonProps } = props;
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    useEffect(() => {
        if (!disabled) {
            setOpen(false);
            setConfirmLoading(false);
        }
    }, [disabled]);
    const showPopconfirm = () => {
        setOpen(true);
    };
    const handleOk = async () => {
        setConfirmLoading(true);
        onConfirm(() => {
            setOpen(false);
            setConfirmLoading(false);
        });
    };
    const handleCancel = () => {
        setOpen(false);
    };
    return (React.createElement(Popconfirm, { title: title, description: description, open: open, placement: placement, onConfirm: handleOk, okButtonProps: { loading: confirmLoading, disabled: disabled }, onCancel: handleCancel },
        React.createElement(Tooltip, { title: tooltip, zIndex: 1 },
            React.createElement(Button, { onClick: showPopconfirm, ...buttonProps }, buttonProps.label != undefined ? buttonProps.label : title))));
};
